import { ActionTypes } from './types';

export function setTargetExport(exportType: "timelapse" | "video_clip", id: string, kvsName: string) {
  return { type: ActionTypes.SET_TARGET_EXPORT, exportType, id, kvsName };
}

export function clearTargetExport() {
  return { type: ActionTypes.CLEAR_TARGET_EXPORT }
}